//
// ColorModel.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./styles/AttributesModel";

var ColorModel = createModule("gtl::ColorModel", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::AttributesModel"], EventDispatcher, [
    ,
    {
        fillGradientNeutralColor: 10,
        fillGradientStartColor: 10,
        fillGradientEndColor: 10,
        colorList: [10],
    },
    ,
    ,
    {
        copyFromBundle: [0,1],
        getColors: [[10]],
        setStyle: [0,1],
        setStyleElement: [0,4],
        setStyleElementChain: [0,[4]],
    },
    {
        _create: [4],
    },
    ,
]);
export default ColorModel;
